import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import {
    Typography,
    Paper,
    TableContainer,
    TableHead,
    TableRow,
    TableCell,
    Table,
    TableBody,
    Checkbox,
    Button
} from '@material-ui/core';
import HelpToolTip from '../HelpToolTip';
import ReactLoading from 'react-loading';

const headCells = [
    { id: 'check', numeric: false, disablePadding: false, label: '', width: 'auto', textAlign: 'left' },
    { id: 'recordId', numeric: false, disablePadding: false, label: 'レコード番号', width: 'auto', textAlign: 'left' },
    { id: 'creationTime', numeric: false, disablePadding: false, label: '受付日時', width: 'auto', textAlign: 'left' },
    { id: 'reportDate', numeric: false, disablePadding: false, label: '確認日時', width: 'auto', textAlign: 'left' },
    { id: 'categoryName', numeric: false, disablePadding: false, label: 'カテゴリ名', width: 'auto', textAlign: 'left' },
    { id: 'shubetsuName', numeric: false, disablePadding: false, label: '報告種別名', width: 'auto', textAlign: 'left' },
    { id: 'memo', numeric: false, disablePadding: false, label: 'メモ（報告内容）', width: 'auto', textAlign: 'left' },
    { id: 'address', numeric: false, disablePadding: false, label: '住所', width: 'auto', textAlign: 'left' },
    { id: 'endFlg', numeric: false, disablePadding: false, label: '終了フラグ', width: 'auto', textAlign: 'left' },
    { id: 'url', numeric: false, disablePadding: false, label: '詳細', width: 'auto', textAlign: 'left' },
];

const styles = () => ({
    root: {
        width: '100%',
    },
    paper: {
        width: '95%',
        marginTop: '20px',
    },
    tableHeadColor: {
        backgroundColor: '#edeff0',
        borderColor: '#dee2e6',
        color: '#495057',
    },
    table: {
        minWidth: 1000,
    },
    cell: {
        display: 'block',
    },
    wordBreak: {
        width: '100%',
        wordBreak: 'break-all',
        whiteSpace: 'pre-wrap',
    },
    lengthTypography: {
        fontSize: '18px',
        marginTop: '10px',
    },
    center: {
        justifyContent: 'center',
        alignItems:'center',
        margin: '50px auto 50px auto',
    }
});

//ヘルプアイコンの文言
const infoText = '同じユーザからの報告にチェックを入れた場合は、\n１人としてカウントします。'

function SupponetUserTableHead(props) {
    const { classes, order, orderBy, allUpdateFlg, allUpdate, allData } = props;

    return (
        <TableHead className={classes.tableHeadColor}>
            <TableRow>
                {headCells.map((headCell) => (
                    <TableCell
                        key={headCell.id}
                        align={headCell.numeric ? 'right' : 'left'}
                        padding={headCell.disablePadding ? 'none' : 'default'}
                        sortDirection={orderBy === headCell.id ? order : false}
                    >
                        {headCell.label}
                        { (headCell.id === 'check' && allData.length !== 0 ) && (
                            <Checkbox
                                checked={allUpdateFlg}
                                onChange={(event) => allUpdate(event)}
                            />
                        )}
                    </TableCell>
                ))}
            </TableRow>
        </TableHead>
    );
}

const SupponetUserTable = (props) => {
    const { classes, datas, allData, setData, allUpdate, setAllUpdate, isLoading } = props;
    const [order, setOrder] = React.useState('asc');
    const [orderBy, setOrderBy] = React.useState('recordId');
    const [update, setUpdata]= React.useState(false);
    const handleRequestSort = (event, property) => {
        const isAsc = orderBy === property && order === 'asc';
        setOrder(isAsc ? 'desc' : 'asc');
        setOrderBy(property);
    };

    const handleChangeAllUserCheck = (event) => {
        const copyAllData = allData;
        let res;
        if(!allUpdate){
            res = window.confirm('すべて選択しますか？');
        }
        else{
            res = window.confirm('すべての選択を解除しますか？');
        }
        if(res){
            for(let i = 0; i < copyAllData.length; i++ ){
                copyAllData[i].checked = event.target.checked;
            }
            setData(copyAllData);
            setAllUpdate(allUpdate ? false : true);
        }
    };


    const handleChangeUserCheck = (event, userData) => {
        const copyAllData = allData;
        for(let i = 0; i < copyAllData.length; i++ ){
            if(copyAllData[i].recordId === userData.recordId){
                copyAllData[i].checked = event.target.checked;
                break;
            }
        }
        setData(copyAllData);
        setUpdata(update ? false : true);
    };

    //ユーザIDの重複を排除した送信人数の計算
    const dupDataLength = () => {
        const user = [];
        allData.map((d) => {
            if(d.checked){
                const userIndex = user.findIndex((findItem) => {
                    return d.userId === findItem.userId;
                });
                if( userIndex === -1 ) user.push(d);
            }
        });
        return user.length;
    }

    return (
        <React.Fragment>
            { isLoading ? (
                <ReactLoading
                    className={classes.center}
                    type={'spin'}
                    color={'black'}
                    height={'50px'}
                    width={'50px'}
                />
            )
            :
            (
                <Paper className={classes.paper}>
                    <TableContainer>
                        <Table className={classes.table} aria-labelledby="tableTitle" aria-label="draft table">
                            <SupponetUserTableHead
                                classes={classes}
                                order={order}
                                orderBy={orderBy}
                                onRequestSort={handleRequestSort}
                                rowCount={datas.length}
                                allUpdateFlg={allUpdate}
                                allUpdate={handleChangeAllUserCheck}
                                allData={allData}
                            />

                            <TableBody>
                                {datas.map((data, index) => {
                                    const labelId = `deliveryError-data-table-checkbox-${index}`;
                                    return (
                                        <TableRow
                                            hover
                                            tabIndex={-1}
                                            // key={data.recordId}
                                            key={data.recordId}
                                        >
                                            <TableCell
                                                component="th"
                                                id={labelId}
                                                // scope='row'
                                                padding={headCells[0].disablePadding ? 'none' : 'default'}
                                                align={'center'}
                                                style={{minWidth: '100px', textAlign: headCells[0].textAlign}}
                                            >

                                            <Checkbox
                                                checked={data.checked} onChange={(event) => handleChangeUserCheck(event, data)}
                                            />
                                            </TableCell>
                                            <TableCell
                                                component="th"
                                                id={labelId}
                                                // scope='row'
                                                padding={headCells[1].disablePadding ? 'none' : 'default'}
                                                align={'center'}
                                                style={{minWidth: '100px', textAlign: headCells[1].textAlign}}
                                            >
                                                <div className={classes.cell}>
                                                    <p>{data.recordId}</p>
                                                </div>
                                            </TableCell>
                                            <TableCell
                                                component="th"
                                                id={labelId}
                                                // scope='row'
                                                padding={headCells[2].disablePadding ? 'none' : 'default'}
                                                align={'center'}
                                                style={{minWidth: '100px', textAlign: headCells[1].textAlign}}
                                            >
                                                <div className={classes.cell}>
                                                    <p>{data.creationTime}</p>
                                                </div>
                                            </TableCell>
                                            <TableCell
                                                component="th"
                                                id={labelId}
                                                // scope='row'
                                                padding={headCells[3].disablePadding ? 'none' : 'default'}
                                                align={'center'}
                                                style={{minWidth: '100px', textAlign: headCells[2].textAlign}}
                                            >
                                                <div className={classes.cell}>
                                                    <p>{data.reportDate}</p>
                                                </div>
                                            </TableCell>
                                            <TableCell
                                                component="th"
                                                id={labelId}
                                                // scope='row'
                                                padding={headCells[4].disablePadding ? 'none' : 'default'}
                                                align={'center'}
                                                style={{minWidth: '100px', textAlign: headCells[3].textAlign}}
                                            >
                                                <div className={classes.cell}>
                                                    <p>{data.categoryName}</p>
                                                </div>
                                            </TableCell>
                                            <TableCell
                                                component="th"
                                                id={labelId}
                                                // scope='row'
                                                padding={headCells[5].disablePadding ? 'none' : 'default'}
                                                align={'center'}
                                                style={{minWidth: '100px', textAlign: headCells[4].textAlign}}
                                            >
                                                <div className={classes.cell}>
                                                    <p>{data.shubetsuName}</p>
                                                </div>
                                            </TableCell>
                                            <TableCell
                                                component="th"
                                                id={labelId}
                                                // scope='row'
                                                padding={headCells[6].disablePadding ? 'none' : 'default'}
                                                align={'center'}
                                                style={{minWidth: '100px', textAlign: headCells[4].textAlign}}
                                            >
                                                <div
                                                    placement="bottom"
                                                >
                                                    <p className={classes.wordBreak}>{data.memo}</p>
                                                </div>
                                                {/* <div className={classes.cell}>
                                                    <p>{data.memo}</p>
                                                </div> */}
                                            </TableCell>
                                            <TableCell
                                                component="th"
                                                id={labelId}
                                                // scope='row'
                                                padding={headCells[7].disablePadding ? 'none' : 'default'}
                                                align={'center'}
                                                style={{minWidth: '100px', textAlign: headCells[4].textAlign}}
                                            >
                                                <div className={classes.cell}>
                                                    <p>{data.address}</p>
                                                </div>
                                            </TableCell>
                                            <TableCell
                                                component="th"
                                                id={labelId}
                                                // scope='row'
                                                padding={headCells[8].disablePadding ? 'none' : 'default'}
                                                align={'center'}
                                                style={{minWidth: '100px', textAlign: headCells[4].textAlign}}
                                            >
                                                <div className={classes.cell}>
                                                    <p>{data.endFlg}</p>
                                                </div>
                                            </TableCell>
                                            <TableCell
                                                component="th"
                                                id={labelId}
                                                // scope='row'
                                                padding={headCells[9].disablePadding ? 'none' : 'default'}
                                                align={'center'}
                                                style={{minWidth: '100px', textAlign: headCells[4].textAlign}}
                                            >
                                                <div className={classes.cell}>
                                                    <Button variant="contained" onClick={() => window.open(data.url, '_blank')}>詳細</Button>
                                                </div>
                                            </TableCell>
                                        </TableRow>
                                    );
                                })}
                            </TableBody>
                        </Table>
                    </TableContainer>
                </Paper>
            )}
            { allData.length !== 0 && !isLoading && (
                <Typography className={classes.lengthTypography}>
                    {`送信人数：${dupDataLength()}人`}
                    <HelpToolTip infoText={infoText} />
                </Typography>
            )}
        </React.Fragment>
    );
};

SupponetUserTable.propTypes = {
    classes: PropTypes.object.isRequired,
    datas: PropTypes.array.isRequired,
    allData: PropTypes.array.isRequired,
    setData: PropTypes.func.isRequired,
};

SupponetUserTableHead.propTypes = {
    classes: PropTypes.object.isRequired,
    order: PropTypes.oneOf(['asc', 'desc']).isRequired,
    orderBy: PropTypes.string.isRequired,
    allUpdateFlg: PropTypes.bool.isRequired,
    allUpdate: PropTypes.func.isRequired,
    allData: PropTypes.array.isRequired
};

export default withStyles(styles)(SupponetUserTable);